import { canUseDOM } from 'exenv';

export default function loadNielsenTracker() {
  if (canUseDOM) {
    window.Nielsen_Event();
  }
}
